import bg from '../assets/bg.png';
import tattooMachine from '../assets/tattooMachine.png';
import hand from '../assets/hand.png';
import nick from '../assets/nick.jpg';
import vito from '../assets/vito.jpg';
import maria from '../assets/maria.jpg';
import griselda from '../assets/griselda.jpg';
import carlo from '../assets/carlo.jpg';
import raffaella from '../assets/raffaella.jpg';
import domenico from '../assets/domenico.jpg';
import rosetta from '../assets/rosetta.jpg';
import kelly from '../assets/kelly.png';
import keanu from '../assets/keanu.png';
import rihanna from '../assets/rihanna.png';
import megan from '../assets/megan.png';
import hp from '../assets/hp.png';
import hb from '../assets/hb.png';
import lat from '../assets/lat.png';
import mtv from '../assets/mtv.png';
import ny from '../assets/ny.png';
import nyt from '../assets/nyt.png';
import obs from '../assets/obs.png';
import r29 from '../assets/r29.png';
import vogue from '../assets/vogue.png';
import wwd from '../assets/wwd.png';
import ty from '../assets/ty.png';
import machine from '../assets/machine.png';
import banner from '../assets/banner.jpg';


export default {
  bg,
  tattooMachine,
  hand,
  nick,
  vito,
  maria,
  griselda,
  carlo,
  raffaella,
  domenico,
  rosetta,
  kelly,
  keanu,
  rihanna,
  megan,
  hp,
  hb,
  lat,
  mtv,
  ny,
  nyt,
  obs,
  r29,
  vogue,
  wwd,
  ty,
  machine,
  banner,
};
